<script setup lang="ts">
import { computed } from 'vue'
const props = defineProps<{label:string;icon?:string;tone?:'emerald'|'cyan'|'blue'|'amber'|'purple'|'red'}>()
defineEmits<{(e:'click'):void}>()
const toneClass = computed(() => ({
  emerald:'border-emerald-500/20 bg-emerald-500/10 text-emerald-300',cyan:'border-cyan-500/20 bg-cyan-500/10 text-cyan-300',
  blue:'border-blue-500/20 bg-blue-500/10 text-blue-300',amber:'border-amber-500/20 bg-amber-500/10 text-amber-300',
  purple:'border-purple-500/20 bg-purple-500/10 text-purple-300',red:'border-red-500/20 bg-red-500/10 text-red-300'
}[props.tone || 'emerald']))
const glyph = computed(() => ({report:'▤',tank:'▣',well:'⌁',ticket:'⌑',watch:'!',safety:'✓',crew:'👷',dispatch:'↗'}[props.icon || 'report'] || '•'))
</script>
<template>
  <button class="group rounded-xl border border-slate-700/40 bg-slate-700/25 p-3 text-left transition hover:border-emerald-500/30 hover:bg-slate-700/40" @click="$emit('click')">
    <span class="grid h-9 w-9 place-items-center rounded-lg border text-xs font-black" :class="toneClass">{{glyph}}</span>
    <span class="mt-3 block text-xs font-bold text-slate-100">{{label}}</span>
  </button>
</template>
